import { useParams } from 'wouter';
import { AdminDetailPage } from '../../AdminDetailPage';
import { ProfileTabContent } from './ProfileTabContent';
import { AdminOrganizations } from '@platform/client';
import { ProjectTabContent } from './ProjectTabContent';
import { JSX, useState } from 'react';
import { UpdateAppStatusModal } from './UpdateApplicationStatusModal';
import { OrganizationApplicationStatusEnum } from '@platform/client/schemas';
import { MatchesTabContent } from './MatchesTabContent';
import { ProjectSuggestionTabContent } from './ProjectSuggestion';
import { OrgEmailTabContent } from './EmailTabContent';

export const OrganizationDetail = () => {
  const { organizationId } = useParams<{ organizationId: string }>();
  const [editAppStatusModalOpen, setEditAppStatusModalOpen] = useState(false);
  const orgIdInt = parseInt(organizationId);
  const {
    data: orgData,
    isLoading,
    isError,
    isSuccess,
  } = AdminOrganizations.useGetReviewData(orgIdInt);

  const tabs: { id: string; content: JSX.Element }[] = [
    { id: 'Profile', content: <ProfileTabContent organizationData={orgData} /> },
    { id: 'Projects', content: <ProjectTabContent organizationId={orgIdInt} /> },
    { id: 'Matches', content: <MatchesTabContent organizationId={orgIdInt} /> },
    { id: 'Emails', content: <OrgEmailTabContent orgId={orgIdInt} /> },
  ];

  if (
    orgData?.applicationStatus === OrganizationApplicationStatusEnum.approved ||
    orgData?.applicationStatus === OrganizationApplicationStatusEnum.approved_match
  ) {
    tabs.push({
      id: 'AI Project Suggest',
      content: <ProjectSuggestionTabContent organizationId={orgIdInt} />,
    });
  }

  return (
    <>
      <AdminDetailPage
        isError={isError}
        isLoading={isLoading}
        isSuccess={isSuccess}
        title={orgData?.name ?? 'MovingWorlds Organization'}
        previewLink={`~/platform/directory/organizations/${organizationId}`}
        tabs={tabs}
        pageActions={[
          {
            text: 'Update Application Status',
            onPress: () => setEditAppStatusModalOpen(true),
            type: 'button',
          },
          {
            text: 'Edit Organization',
            href: `/${organizationId}/edit`,
            type: 'link',
          },
        ]}
      />
      {editAppStatusModalOpen && orgData && (
        <UpdateAppStatusModal
          organizationId={orgData.organizationId}
          applicationId={orgData.applicationId as number}
          status={orgData.applicationStatus as OrganizationApplicationStatusEnum}
          onClose={() => setEditAppStatusModalOpen(false)}
        />
      )}
    </>
  );
};
